import TagShowContainer from './tag_show_container';

const TagShow = TagShowContainer;

export default TagShow;
